import { getLocale } from "@/paraglide/runtime.js";

/**
 * The next `count` days from tomorrow, named the way the visitor's language names them. The
 * drawings on the front page date their sample week with these, so it never shows last month.
 */
export const upcomingDays = (count: number, now = new Date()) =>
  Array.from({ length: count }, (_, index) => {
    const day = new Date(now);
    day.setDate(now.getDate() + index + 1);
    return {
      key: day.toDateString(),
      number: day.getDate(),
      short: new Intl.DateTimeFormat(getLocale(), { weekday: "short" }).format(day),
    };
  });
